/* eslint-disable max-lines-per-function */
import classNames from 'clsx';
import { ReactComponent as SharedIcon } from 'img/icons/shared.svg';
import React, { useMemo } from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { Hint } from 'reactApp/ui/Hint/Hint';
import { useWindowWidth } from 'reactApp/ui/VirtualList/VirtualList.hooks';
import { CancelIcon } from 'reactApp/ui/VKUIIcons';

import styles from '../../DataListItemRow.css';
import newStyles from '../../DataListItemRow.new.css';
import { IncomingItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox';
import { ItemName } from '../ItemName';
import { Pic } from '../Pic';
import { Incoming } from '../RowFor/Incoming';
import { Size } from '../Size';

const SharedIncomingItem = (props: IncomingItemProps) => {
    const windowWidth = useWindowWidth();
    const { access, onCheckboxClick, isSelected, kind, owner, name, size, isMounted, onAccept, onReject, onMount } = props;

    const accesText = useMemo(() => {
        if (access === 'read_only') {
            return 'Просмотр';
        }

        return 'Редактирование';
    }, [access]);

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            variant1={<Incoming {...props} checkboxClassname={newStyles.check} />}
            control={
                <>
                    <Checkbox onCheckboxClick={onCheckboxClick} isSelected={isSelected} />
                    <Pic isFolder={true} kind={kind} author={owner} />
                    {!ENABLE_FULL_RESPONSIVE ? (
                        <>
                            <ItemName name={name} />
                            <div className={styles.access}>{accesText}</div>
                            <Size size={size} />
                            {!isMounted ? (
                                <div className={styles.buttons}>
                                    <Hint text="Принять приглашение">
                                        <button className={classNames(styles.button, styles.button_accept)} onClick={onAccept}>
                                            Принять
                                        </button>
                                    </Hint>
                                    <Hint text="Отклонить приглашение">
                                        <button className={styles.button} onClick={onReject}>
                                            Отклонить
                                        </button>
                                    </Hint>
                                </div>
                            ) : (
                                <Hint text="Настроить доступ">
                                    <div className={styles.mount} onClick={onMount}>
                                        <SharedIcon width={18} height={12} />
                                    </div>
                                </Hint>
                            )}
                        </>
                    ) : (
                        <>
                            {windowWidth > BREAKPOINT_SM ? (
                                <>
                                    <ItemName name={name} />
                                    <div className={styles.access}>{accesText}</div>
                                </>
                            ) : (
                                <div className={styles.responsiveNameWrapper}>
                                    <ItemName name={name} />

                                    <span className={styles.responsiveDateWrapper}>
                                        <div className={styles.access}>{accesText}</div>
                                        <Size size={size} />
                                    </span>

                                    {!isMounted && (
                                        <Hint text="Принять приглашение">
                                            <button
                                                className={classNames(styles.button, styles.button_accept, styles.button_accept_responsive)}
                                                onClick={onAccept}
                                            >
                                                Принять
                                            </button>
                                        </Hint>
                                    )}
                                </div>
                            )}

                            {windowWidth > BREAKPOINT_SM ? (
                                <>
                                    <Size size={size} />
                                    {!isMounted ? (
                                        <div className={styles.buttons}>
                                            <Hint text="Принять приглашение">
                                                <button className={classNames(styles.button, styles.button_accept)} onClick={onAccept}>
                                                    Принять
                                                </button>
                                            </Hint>
                                            <Hint text="Отклонить приглашение">
                                                <button className={styles.button} onClick={onReject}>
                                                    Отклонить
                                                </button>
                                            </Hint>
                                        </div>
                                    ) : (
                                        <Hint text="Настроить доступ">
                                            <div className={styles.mount} onClick={onMount}>
                                                <SharedIcon width={18} height={12} />
                                            </div>
                                        </Hint>
                                    )}
                                </>
                            ) : (
                                <>
                                    {isMounted && (
                                        <Hint text="Настроить доступ">
                                            <div className={classNames(styles.mount, styles.mountResponsive)} onClick={onMount}>
                                                <SharedIcon width={18} height={12} />
                                            </div>
                                        </Hint>
                                    )}
                                    {!isMounted && (
                                        <Hint text="Отклонить приглашение">
                                            <button className={styles.reject} onClick={onReject}>
                                                <CancelIcon />
                                            </button>
                                        </Hint>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </>
            }
        />
    );
};

export default SharedIncomingItem;
